import React from 'react';

export default ({ count = 0 }) => {
  if (count < 1) {
    return null;
  }

  return <span className="swing-submittal-pending-count">{count}</span>;
};



// WEBPACK FOOTER //
// ./src/swing-submittals/SwingSubmittalsPendingReviewCount.js